import { createClient } from "@sanity/client";

export default createClient({
  projectId: "dj2u109o",      // your project ID
  dataset: "production",
  apiVersion: "2023-07-07",   // pick a date (today or recent)
  useCdn: true,
});
